export const applyGiftcardBase = ({ setToken, execute }) => async (cartId, giftcardCode) => execute(await setToken({
    method: "POST",
    uri: `/ctp/carts/${cartId}/applyGiftcard`,
    body: { giftcardCode },
}));
